import { IAppTitle } from '~/interfaces/plugins/helper'
import { globalLogger } from '~/plugins/logger'
import * as XLSX from 'xlsx'
import { IStringMap } from '@/classes/salary/salary-period'
import { TYPE } from 'vue-toastification'
import Toast, { toastInstance, toastOptions } from '~/plugins/toast.js'
import i18n, { hotreload, i18nInstance } from '~/plugins/localization'
import jalaliMoment from 'jalali-moment'
import { bdDiv, bdFloor, bdMul, bdRound, bdSub, toNum } from '~/plugins/big-decimal-helper'
import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'

import packageJson from '../../package.json'
const { title } = packageJson

export class AppTitle implements IAppTitle {

	private readonly defaultTitle: string = title
	currentTitle: string = title
	duration: number
	tickTitle!: string
	intervalId?: number

	constructor(tickTile: string, duration: number) {
		this.setTickTitle(tickTile)
		this.duration = duration
	}

	setInterval(tickTitle: string = this.tickTitle, duration: number = this.duration): void {

		if (!this.tickTitle.length)
			globalLogger.warn('tickTitle is Empty!')

		this.intervalId = setInterval(() => {
			document.title = this.currentTitle

			setTimeout(() => {
				document.title = tickTitle
			}, duration)
		}, duration * 2)
	}

	clearInterval(intervalId: number): void {
		clearInterval(intervalId)
	}

	setTickTitle(tickTile: string = ''): void {
		this.tickTitle = tickTile
	}

	getIntervalId(): number | undefined {
		return this.intervalId
	}

	changeDuration(duration: number): void {
		this.duration = duration
	}

	setCompanyNameOnTitle(name: string) {
		this.currentTitle = name ? `${this.defaultTitle} • ${name}` : this.defaultTitle
		document.title = this.currentTitle
	}
}

export const GlobalAppTitle = new AppTitle('', 1000)

export function calcNotTranslateTables(tableList: [any]): void {
	var p = /^[\u0600-\u06FF\s]+$/
	let notTranslateArr: any[] = []
	tableList.forEach((x: any) => {
		if (!p.test(x.entityTitle[0])) notTranslateArr.push(x.entityType)
		x.columns.forEach((y: any) => {
			if (!p.test(y.title[0])) notTranslateArr.push(y.title)
		})
	})
	console.log('result', notTranslateArr)
}

export function idGenerator(n: number = 5) {
	return Math.random().toString(36).substr(2, n)
}

let uidCounter = 0

export function nextUID(): number {
	uidCounter += 1
	return uidCounter
}

export function generateUUID() {
	var d = new Date().getTime()
	var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0//Time in microseconds since page-load or 0 if unsupported
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16
		if (d > 0) {
			r = (d + r) % 16 | 0
			d = Math.floor(d / 16)
		} else {
			r = (d2 + r) % 16 | 0
			d2 = Math.floor(d2 / 16)
		}
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
	})
}

export function importExcel(event: any, colKeys: IStringMap<any>): Promise<any> {
	return new Promise((resolve, reject) => {

		const file = event.target.files[0]
		const splitName = file.name.split('.')
		if (splitName[splitName.length - 1] === 'xlsx' || splitName[splitName.length - 1] === 'xls') {
			const reader = new FileReader()
			reader.onload = (e) => {
				if (e.target) {
					/* Parse data */
					const bstr = e.target.result
					const wb = XLSX.read(bstr, { type: 'binary' })
					/* Get first worksheet */
					const wsname = wb.SheetNames[0]
					const ws = wb.Sheets[wsname]
					/* Convert array of arrays */
					const rows: any[] = XLSX.utils.sheet_to_json(ws, { header: 1 })
					const bankPaymentObjIndex: any = {}
					rows[0].forEach((x: string, ind: number) => {
						bankPaymentObjIndex[ind] = colKeys[x]
					})
					if (Object.values(bankPaymentObjIndex).some(x => !x)) {
						toastInstance(i18nInstance.global.t('salary.bank-payment-announce.m.excel-column-not-exist'))
						reject()
					}

					const result = rows.reduce((a: any[], c: any[], ind: number) => {
						if (ind !== 0) {
							a.push(c.reduce((a2, c2, ind2) => {
								if (typeof bankPaymentObjIndex[ind2] === 'string') {

									const splittedProp = bankPaymentObjIndex[ind2].split('.')
									splittedProp.reduce((acc: any, key: string, index: number) => {
										if (index === splittedProp.length - 1) {
											// Last key, assign the value
											acc[key] = c2
										} else {
											// Check if the key exists, if not, create an empty object
											acc[key] = acc[key] || {}
										}
										return acc[key] // Return the current object for the next iteration
									}, a2)
								} else
									a2[bankPaymentObjIndex[ind2]] = c2
								return a2
							}, { id: idGenerator(10) }))
							return a
						}
						return a
					}, [])
					resolve(result.filter((x: any) => !(x.id && Object.keys(x).length === 1)))
				}
			}

			reader.readAsBinaryString(file)
		}
		// if (splitName[splitName.length - 1] === 'xlsx' || splitName[splitName.length - 1] === 'xls') {
		//   readXlsxFile(event.target.files[0]).then((rows: any[]) => {
		//
		//
		//   })
		// }
		else {
			toastInstance(i18nInstance.global.t('salary.bank-payment-announce.m.not-supported-files'))
			reject()
		}
	})

}

export function smartUnit(uValue: any, unit: any, units: any[]) {
	function smartUnitByFloatRateValue(val: any, unit: any, units: any[]) {
		let result = ""
		let valueStr = bdMul(val, unit.rate)

		if (units.length <= 1) {
			return `${valueStr} ${units[0].name}`
		}

		let count = 0
		let toFixedRoundedNumber = 0
		let decimalPart = ""
		let currentRate
		let resultUnit: any = {}
		for (var i = units.length - 1; i >= 0; i--) {
			if (units[i].rate >= unit.rate) {
				currentRate = parseFloat(units[i].rate)
				if (i != 0) {
					var decimalParts = currentRate.toString().split(".")
					if (decimalParts.length > 1) {
						decimalPart = decimalParts[1]
						toFixedRoundedNumber = decimalPart.length
					}
				}
				if (currentRate == 1) {
					count = toNum(bdRound(valueStr, toFixedRoundedNumber))
				} else {
					count = toNum(bdFloor(bdDiv(valueStr, String(currentRate))))
				}
				if (count > 0) {
					if (result == "") {
						result = `${Number(count.toFixed(toFixedRoundedNumber))} ${units[i].name}`
					} else {
						result += ` ${count} ${units[i].name}`
					}
				}
				resultUnit.ucount = count
				resultUnit.name = units[i].name
				valueStr = bdSub(valueStr, bdMul(String(currentRate), count))
			}
		}

		if (
			resultUnit.name == unit.name &&
			resultUnit.ucount == val &&
			units.length > 1
		) {
			units = [units[0]]
			return smartUnitByFloatRateValue(bdMul(val, unit.rate), units[0], units)
		}
		return result
	}

	function smartUnitByIntRateValue(val: any, unit: any, units: any[]) {
		let result = ""
		let value = toNum(bdMul(val, unit.rate))

		if (units.length <= 1) {
			return `${value} ${units[0].name}`
		}

		let count = 0
		let resultUnit: any = {}
		for (var i = units.length - 1; i >= 0; i--) {
			if (units[i].rate >= unit.rate) {
				count = Math.floor(toNum(bdDiv(value, units[i].rate)))
				if (count > 0) {
					if (result == "") {
						result = `${count} ${units[i].name}`
					} else {
						result += ` ${count} ${units[i].name}`
					}
					resultUnit.ucount = count
					resultUnit.name = units[i].name
				}
				value = toNum(bdSub(value, bdMul(units[i].rate, count)))
			}
		}
		if (
			resultUnit.name == unit.name &&
			resultUnit.ucount == val &&
			units.length > 1
		) {
			value = toNum(bdMul(val, unit.rate))
			units = [units[0]]
			return smartUnitByIntRateValue(value, units[0], units)
		}
		return result
	}

	let hasFloatRate = false
	units.forEach((item) => {
		const rate = parseFloat(item.rate)
		if (!Number.isNaN(rate) && rate % 1 !== 0) {
			hasFloatRate = true
		}
	})

	let sortedUnits = []
	for (var i = 0; i < units.length; i++) {
		if (hasFloatRate) {
			sortedUnits.push({
				name: units[i].name,
				rate: parseFloat(units[i].rate),
			})
		} else {
			sortedUnits.push({ name: units[i].name, rate: parseInt(units[i].rate) })
		}
	}
	sortedUnits.sort((a: any, b: any) => {
		if (hasFloatRate) {
			return parseFloat(a.rate) - parseFloat(b.rate)
		}
		else {
			return parseInt(a.rate) - parseInt(b.rate)
		}

	})

	if ((sortedUnits || []).length <= 1 || (unit.rate === sortedUnits[0].rate && uValue < sortedUnits[1].rate))
		return ''

	if (hasFloatRate) {
		return smartUnitByFloatRateValue(uValue, unit, sortedUnits)
	} else {
		return smartUnitByIntRateValue(uValue, unit, sortedUnits)
	}
}

/// <summary>
///   check id if it changed in data source
/// !!remove property after checking ids
/// </summary>
export function idCheckChanged(property: string, source1: any, source2: any) {
	const selectProp = (source1: any, source2: any, props: string[]): any => {
		// debugger
		let changed = false

		if (!source1 || !source2) return true
		if (Array.isArray(source1[props[0]])) {
			const insideSource1 = source1[props[0]]
			const insideSource2 = source2[props[0]]
			let length = insideSource1.length
			changed = insideSource1?.length !== insideSource2?.length
			if (!changed)
				while (!changed && length) {
					// debugger
					if (props.length === 1) {
						changed = insideSource1[length - 1]?.id !== insideSource2[length - 1]?.id
						delete insideSource1[length - 1]
						delete insideSource2[length - 1]
					} else {
						changed = selectProp(insideSource1[length - 1], insideSource2[length - 1], props.slice(1, props.length))
					}
					length--
				}
		} else {
			if (props.length === 1) {
				changed = source1[props[0]]?.id !== source2[props[0]]?.id
				delete source1[props[0]]
				delete source2[props[0]]
			} else {
				changed = selectProp(source1[props[0]], source2[props[0]], props.slice(1, props.length - 1))
			}
		}
		return changed

	}

	const splitProperty = property.split('.')

	return selectProp(source1, source2, splitProperty)
}

export function changeTimeToNow(date: string) {
	let momentDate = jalaliMoment(date, 'YYYY-MM-DDTHH:mm:ss')

	let now = jalaliMoment()

	momentDate.hour(now.hour())
	momentDate.minute(now.minute())
	momentDate.second(now.second())

	return momentDate.format('YYYY-MM-DDTHH:mm:ss')
}

export function getChequeStateForTranslate(state: string, isPayment: boolean) {
	const lowerCaseState = state.toLowerCase()
	return !isPayment && lowerCaseState === 'pending' ? 'atCashDesk' : state
}

export function appendFormData(formData: FormData, data: Record<string, any>, rootKey = "") {
	for (const key in data) {
		const value = data[key]
		const formKey = rootKey ? `${rootKey}.${key}` : key

		if (value instanceof File) {
			formData.append(formKey, value)
		} else if (Array.isArray(value)) {
			value.forEach((item, index) => {
				appendFormData(formData, { [index]: item }, formKey)
			})
		} else if (typeof value === "object" && value !== null) {
			appendFormData(formData, value, formKey)
		} else {
			formData.append(formKey, value)
		}
	}
}

export function convertDateToPersian(date: string) {
	if (!date || date.includes('0001-01-01')) return ''

	return jalaliMoment(date, 'YYYY-MM-DDTHH:mm:ss').locale('fa').format('jYYYY/jMM/jDD')
}

export async function getEntityNotes(entityType: string, entityId: string) {
	const url = Endpoints.getUrl('note.get')
	const data = {
		entityType,
		entityId,
	}
	const response = await post(url, data, null, { silent: true })
	return response.data
}

export function generateRandomNumber(length: number = 10) {
	return Number(Math.random().toString(36).substr(2, length))
}